page.loadedData = true,
page.serverEvents = function(){

    if(locale == 'en_US'){
        return false;
    }

    let evtSource = new EventSource(ajaxurl+"?action=market_data" , { withCredentials: true });

    evtSource.onopen = function() {
        console.log(locale );
        console.log("Connection to server opened.");
    };

    evtSource.onmessage = function(e) {

        let stickyMarketObj = page.main.fr.setStickyMarker;

        let data = JSON.parse(e.data);

        let timeout = 1900;
        let newObj = {};
        let newCur = {};
        let updateMarket = [];
        let updateCurrency = [];

        console.log(element);
        function changeStatus(element,status, equil){
            let $parent = $(element).parent();
            switch(status){
                case('up'):
                    if(!equil){
                        $parent
                            .removeClass('nr-low')
                            .removeClass('nr-high')
                            .addClass('change-high');
                        setTimeout(function(){
                            $parent
                                .removeClass('change-high')
                                .addClass('nr-high');
                        },timeout);
                    }
                    break;
                case('down'):
                    if(!equil){
                        $parent
                            .removeClass('nr-low')
                            .removeClass('nr-high')
                            .addClass('change-low');
                        setTimeout(function(){
                            $parent
                                .removeClass('change-low')
                                .addClass('nr-low');
                        },timeout);
                    }
                    break;
                default:
                    $parent
                        .removeClass('nr-low')
                        .removeClass('nr-high');
                    break;
            }
        }
        function changeDirection(element, value){

            let $container = $(element).parent();
            $container.removeClass('val-negative').removeClass('val-positive').removeClass('val-def');

            if(Number(value) > 0){
                $container.addClass('val-positive');
            }
            if(Number(value) < 0){
                $container.addClass('val-negative')
            }
            if(Number(value) === 0){
                $container.addClass('val-def');
            }
            if(value === '-' || typeof value === 'undefined'){
                $container.removeClass('val-negative').removeClass('val-positive').removeClass('val-def');
            }

        }

        $.each(data['market'], function (index, market) {
            $.each(market.deliveries, function (delNr, delivery) {


                let $oldRow = $('[data-code="' + delivery.code + '"]');
                let $last = $oldRow.find('.tb-last--old');
                let $netCNG = $oldRow.find('.tb-netCNG--old');
                let $netCHNP = $oldRow.find('.tb-netCNGp--old');
                let $bidSize = $oldRow.find('.tb-bidSize--old');
                let $bid = $oldRow.find('.tb-bid--old');
                let $ask = $oldRow.find('.tb-ask--old');
                let $askSize = $oldRow.find('.tb-askSize--old');
                let $settl = $oldRow.find('.tb-settl--old');
                let $high = $oldRow.find('.tb-high--old');
                let $low = $oldRow.find('.tb-low--old');

                newObj.code = delivery.code;
                newObj.last = delivery.price.last.value;

                newObj.netCng = delivery.price.stats.perf;
                newObj.netCngStatus = delivery.price.stats.statusPerf;
                newObj.netCngEquil = delivery.price.stats.statusPerfEquil;

                newObj.netCngp = delivery.price.stats.relPerf;
                newObj.netCngpStatus = delivery.price.stats.statusPerfPercent;
                newObj.netCngpEquil = delivery.price.stats.statusPerfPercentEquil;

                newObj.bid = delivery.price.bid.value;
                newObj.bidStatus = delivery.price.bid.statusValue;
                newObj.bidEquil = delivery.price.bid.statusValueEquil;

                newObj.bidSize = delivery.price.bid.volume;
                newObj.bidSizeStatus = delivery.price.bid.statusVolume;
                newObj.bidSizeEquil = delivery.price.bid.statusVolumeEquil;

                newObj.ask = delivery.price.ask.value;
                newObj.askStatus = delivery.price.ask.statusValue;
                newObj.askEquil = delivery.price.ask.statusValueEquil;

                newObj.askSize = delivery.price.ask.volume;
                newObj.askSizeStatus = delivery.price.ask.statusVolume;
                newObj.askSizeEquil = delivery.price.ask.statusVolumeEquil;

                newObj.settl = delivery.settlementPrice;
                newObj.settlStatus = delivery.settlementPriceStatus;
                newObj.settlEquil = delivery.settlementPriceEquil;

                newObj.high = delivery.price.high.value;
                newObj.highStatus = delivery.price.high.statusValue;
                newObj.highEquil = delivery.price.high.statusValueEquil;

                newObj.low = delivery.price.low.value;
                newObj.lowStatus = delivery.price.low.statusValue;
                newObj.lowEquil = delivery.price.low.statusValueEquil;


                if($('.altMark-container').length > 0) {
                    $last.html(newObj.last);

                    $netCNG.html(newObj.netCng);

                    changeStatus($netCNG, newObj.netCngStatus, newObj.netCngEquil);
                    changeDirection($netCNG, newObj.netCng);
                    if(typeof newObj.netCngp == 'number'){

                        changeDirection($netCHNP, newObj.netCngp);
                        newObj.netCngp = newObj.netCngp.toFixed(2)   + ' %';
                    }
                    $netCHNP.html(newObj.netCngp);

                    changeStatus($netCHNP, newObj.netCngpStatus, newObj.netCngpEquil);


                    $bid.html(newObj.bid);

                    $bidSize.html(newObj.bidSize);

                    $ask.html(newObj.ask);

                    $askSize.html(newObj.askSize);

                    $settl.html(newObj.settl);
                    changeStatus($settl, newObj.settlStatus, newObj.settlEquil);

                    $high.html(newObj.high);

                    $low.html(newObj.low);

                }
                if(delNr == 0 && stickyMarketObj.requiredMarkets.includes(market.name)){
                    newObj.name = market.name;

                    updateMarket.push(newObj);
                }
                newObj = {};
            });
        });
        let $curr = $('.altMark-static'); // todo
        $.each(data['currency'], function (index, currency) {

            //  console.log(currency.quote);


            let $oldRow = $($curr[index]);
            let $lastC = $oldRow.find('.tb-last--old');
            let $netCNG = $oldRow.find('.tb-netCNG--old');
            let $netCHNP = $oldRow.find('.tb-netCNGp--old');
            let $bidC = $oldRow.find('.tb-bid--old');
            let $askC = $oldRow.find('.tb-ask--old');
            let $settlC = $oldRow.find('.tb-settl--old');
            let $highC = $oldRow.find('.tb-high--old');
            let $lowC = $oldRow.find('.tb-low--old');

            newCur.last = currency.last.value;

            newCur.netCng = currency.stats.perf;
            newCur.netCngStatus = currency.stats.statusPerf;
            newCur.netCngEquil = currency.stats.statusPerfEquil;


            newCur.netCngp = currency.stats.relPerf;
            newCur.netCngpStatus = currency.stats.statusPerfPercent;
            newCur.netCngpEquil = currency.stats.statusPerfPercentEquil;

            newCur.bid = currency.bid.value;

            newCur.ask = currency.ask.value;

            newCur.settl = currency.settlement.value;
            newCur.settlStatus = currency.settlement.settlementPriceStatus;
            newCur.settlEquil = currency.settlement.settlementPriceEquil;


            newCur.high = currency.high.value;

            newCur.low = currency.low.value;

            if($('.altMark-container').length > 0) {
                $lastC.html(newCur.last);

                $netCNG.html(newCur.netCng);
                changeDirection($netCNG, newObj.netCng);
                changeStatus($netCNG, newCur.netCngStatus, newCur.netCngEquil);

                if(typeof newCur.netCngp == 'number'){

                    changeDirection($netCHNP, newObj.netCngp);
                    newCur.netCngp = newCur.netCngp.toFixed(2)   + ' %';
                }
                $netCHNP.html(newCur.netCngp);
                changeStatus($netCHNP, newCur.netCngpStatus, newCur.netCngpEquil);

                $bidC.html(newCur.bid);
                $askC.html(newCur.ask);
                $settlC.html(newCur.settl);
                //changeStatus($settlC, newCur.settlStatus, newCur.settlEquil);

                $highC.html(newCur.high);
                $lowC.html(newCur.low);

            }


            newCur.quote = currency.quote;

            updateCurrency.push(newCur);
            newCur = {};

        });

        stickyMarketObj.loadedArray = [];
        stickyMarketObj.setMarkets(updateMarket, stickyMarketObj.loadedArray);
        updateMarket = [];
        stickyMarketObj.setCurrencies(updateCurrency, stickyMarketObj.loadedArray);
        updateCurrency = [];
        stickyMarketObj.init(stickyMarketObj.loadedArray,true);


        let cDate = new Date();

    };

    evtSource.onerror = function(e) {
        console.log(e);
        console.log("EventSource failed.");
    };


};

page.update = function(){
    if(locale == 'en_US'){
        return false;
    }
    let timeout = 1900;
    let url = ajaxurl+"?action=market_data2";

    function changeStatus(element,status, equil){
        let $parent = $(element).parent();
        switch(status){
            case('up'):
                if(!equil){
                    $parent
                        .removeClass('nr-low')
                        .removeClass('nr-high')
                        .addClass('change-high');
                    setTimeout(function(){
                        $parent
                            .removeClass('change-high')
                            .addClass('nr-high');
                    },timeout);
                }
                break;
            case('down'):
                if(!equil){
                    $parent
                        .removeClass('nr-low')
                        .removeClass('nr-high')
                        .addClass('change-low');
                    setTimeout(function(){
                        $parent
                            .removeClass('change-low')
                            .addClass('nr-low');
                    },timeout);
                }
                break;
            default:
                $parent
                    .removeClass('nr-low')
                    .removeClass('nr-high');
                break;
        }
    }
    function changeDirection(element, value){

        let $container = $(element).parent();
        $container.removeClass('val-negative').removeClass('val-positive').removeClass('val-def');

        if(Number(value) > 0){
            $container.addClass('val-positive');
        }
        if(Number(value) < 0){
            $container.addClass('val-negative');
        }
        if(Number(value) === 0){
            $container.addClass('val-def');
        }
        if(value === '-' || typeof value === 'undefined'){
            $container.removeClass('val-negative').removeClass('val-positive').removeClass('val-def');
        }

    }

    setInterval(function(){
        $.ajax({
        type: 'POST',
        url: url,
        success: function(result){

            if(result ==  0){ return false ;}

            let stickyMarketObj = page.main.fr.setStickyMarker;

            let data = JSON.parse(result);


            let newObj = {};
            let newCur = {};
            let updateMarket = [];
            let updateCurrency = [];

            $.each(data['market'], function (index, market) {
                $.each(market.deliveries, function (delNr, delivery) {


                    let $oldRow = $('[data-code="' + delivery.code + '"]');
                    let $last = $oldRow.find('.tb-last--old');
                    let $netCNG = $oldRow.find('.tb-netCNG--old');
                    let $netCHNP = $oldRow.find('.tb-netCNGp--old');
                    let $bidSize = $oldRow.find('.tb-bidSize--old');
                    let $bid = $oldRow.find('.tb-bid--old');
                    let $ask = $oldRow.find('.tb-ask--old');
                    let $askSize = $oldRow.find('.tb-askSize--old');
                    let $settl = $oldRow.find('.tb-settl--old');
                    let $high = $oldRow.find('.tb-high--old');
                    let $low = $oldRow.find('.tb-low--old');

                    newObj.code = delivery.code;
                    newObj.last = delivery.price.last.value;

                    newObj.netCng = delivery.price.stats.perf;
                    newObj.netCngStatus = delivery.price.stats.statusPerf;
                    newObj.netCngEquil = delivery.price.stats.statusPerfEquil;

                    newObj.netCngp = delivery.price.stats.relPerf;
                    newObj.netCngpStatus = delivery.price.stats.statusPerfPercent;
                    newObj.netCngpEquil = delivery.price.stats.statusPerfPercentEquil;

                    newObj.bid = delivery.price.bid.value;
                    newObj.bidStatus = delivery.price.bid.statusValue;
                    newObj.bidEquil = delivery.price.bid.statusValueEquil;

                    newObj.bidSize = delivery.price.bid.volume;
                    newObj.bidSizeStatus = delivery.price.bid.statusVolume;
                    newObj.bidSizeEquil = delivery.price.bid.statusVolumeEquil;

                    newObj.ask = delivery.price.ask.value;
                    newObj.askStatus = delivery.price.ask.statusValue;
                    newObj.askEquil = delivery.price.ask.statusValueEquil;

                    newObj.askSize = delivery.price.ask.volume;
                    newObj.askSizeStatus = delivery.price.ask.statusVolume;
                    newObj.askSizeEquil = delivery.price.ask.statusVolumeEquil;

                    newObj.settl = delivery.settlementPrice;
                    newObj.settlStatus = delivery.settlementPriceStatus;
                    newObj.settlEquil = delivery.settlementPriceEquil;

                    newObj.high = delivery.price.high.value;
                    newObj.highStatus = delivery.price.high.statusValue;
                    newObj.highEquil = delivery.price.high.statusValueEquil;

                    newObj.low = delivery.price.low.value;
                    newObj.lowStatus = delivery.price.low.statusValue;
                    newObj.lowEquil = delivery.price.low.statusValueEquil;


                    if($('.altMark-container').length > 0) {
                        $last.html(newObj.last);

                        $netCNG.html(newObj.netCng);

                        changeStatus($netCNG, newObj.netCngStatus, newObj.netCngEquil);
                        changeDirection($netCNG, newObj.netCng);
                        if(typeof newObj.netCngp == 'number'){

                            changeDirection($netCHNP, newObj.netCngp);
                            newObj.netCngp = newObj.netCngp.toFixed(2)   + ' %';
                        }
                        $netCHNP.html(newObj.netCngp);

                        changeStatus($netCHNP, newObj.netCngpStatus, newObj.netCngpEquil);


                        $bid.html(newObj.bid);

                        $bidSize.html(newObj.bidSize);

                        $ask.html(newObj.ask);

                        $askSize.html(newObj.askSize);

                        $settl.html(newObj.settl);
                        changeStatus($settl, newObj.settlStatus, newObj.settlEquil);

                        $high.html(newObj.high);

                        $low.html(newObj.low);

                    }
                    if(delNr == 0 && stickyMarketObj.requiredMarkets.includes(market.name)){
                        newObj.name = market.name;

                        updateMarket.push(newObj);
                    }
                    newObj = {};
                });
            });
            let $curr = $('.altMark-static'); // todo
            $.each(data['currency'], function (index, currency) {

                //  console.log(currency.quote);


                let $oldRow = $($curr[index]);
                let $lastC = $oldRow.find('.tb-last--old');
                let $netCNG = $oldRow.find('.tb-netCNG--old');
                let $netCHNP = $oldRow.find('.tb-netCNGp--old');
                let $bidC = $oldRow.find('.tb-bid--old');
                let $askC = $oldRow.find('.tb-ask--old');
                let $settlC = $oldRow.find('.tb-settl--old');
                let $highC = $oldRow.find('.tb-high--old');
                let $lowC = $oldRow.find('.tb-low--old');

                newCur.last = currency.last.value;

                newCur.netCng = currency.stats.perf;
                newCur.netCngStatus = currency.stats.statusPerf;
                newCur.netCngEquil = currency.stats.statusPerfEquil;


                newCur.netCngp = currency.stats.relPerf;
                newCur.netCngpStatus = currency.stats.statusPerfPercent;
                newCur.netCngpEquil = currency.stats.statusPerfPercentEquil;

                newCur.bid = currency.bid.value;

                newCur.ask = currency.ask.value;

                newCur.settl = currency.settlement.value;
                newCur.settlStatus = currency.settlement.settlementPriceStatus;
                newCur.settlEquil = currency.settlement.settlementPriceEquil;


                newCur.high = currency.high.value;

                newCur.low = currency.low.value;

                if($('.altMark-container').length > 0) {
                    $lastC.html(newCur.last);

                    $netCNG.html(newCur.netCng);
                    changeDirection($netCNG, newObj.netCng);
                    changeStatus($netCNG, newCur.netCngStatus, newCur.netCngEquil);

                    if(typeof newCur.netCngp == 'number'){

                        changeDirection($netCHNP, newObj.netCngp);
                        newCur.netCngp = newCur.netCngp.toFixed(2)   + ' %';
                    }
                    $netCHNP.html(newCur.netCngp);
                    changeStatus($netCHNP, newCur.netCngpStatus, newCur.netCngpEquil);

                    $bidC.html(newCur.bid);
                    $askC.html(newCur.ask);
                    $settlC.html(newCur.settl);
                    //changeStatus($settlC, newCur.settlStatus, newCur.settlEquil);

                    $highC.html(newCur.high);
                    $lowC.html(newCur.low);

                }


                newCur.quote = currency.quote;

                updateCurrency.push(newCur);
                newCur = {};

            });

            stickyMarketObj.loadedArray = [];
            stickyMarketObj.setMarkets(updateMarket, stickyMarketObj.loadedArray);
            updateMarket = [];
            stickyMarketObj.setCurrencies(updateCurrency, stickyMarketObj.loadedArray);
            updateCurrency = [];
            stickyMarketObj.init(stickyMarketObj.loadedArray,true);


            let cDate = new Date();
        }

    });

    },40000)


}